import React from "react";
import BookingGroupList from "../../components/event/BookingGroupList";

const BookingGroupsPage = () => {
    return <BookingGroupList/>
}

export default BookingGroupsPage;